export default "__VITE_ASSET__374646f7__"